import React from 'react';

const DashboardPage = () => {
    return (
        <div>
            <h1 className="text-3xl font-bold">Dashboard</h1>
            <p>Welcome to the MikroNet control panel.</p>
        </div>
    );
};

export default DashboardPage;